export default __webpack_public_path__ + "fcef44c0a906778790935eb6854862f6.svg";